<template>
	<div
		v-if="fakerMethodsOptions.length > 0"
		class="faker-method__container faker-method__container--span">
		<label :for="`${column.name}-faker-method`">Fake Data Type</label>
		<Select
			:id="`${column.name}-faker-method`"
			v-model="fakerMethod"
			class="faker-method__select"
			filter
			option-label="label"
			scroll-height="410px"
			:options="fakerMethodsOptions">
			<template #value="slotProps">
				<div
					v-if="slotProps.value"
					class="faker-method__select-value">
					<div class="faker-method__name">
						{{ slotProps.value.label }}
					</div>
					<div class="faker-method__description">
						{{ slotProps.value.description }}
					</div>
				</div>
				<div
					v-else
					class="faker-method__select-value">
					<div class="faker-method__placeholder">
						Select fake data method to generate data for this column
					</div>
				</div>
			</template>
			<template #option="slotProps">
				<div style="display: flex; flex-direction: column">
					<div style="font-size: 14px; color: var(--p-text-color)">
						{{ slotProps.option.label }}
					</div>
					<div style="font-size: 12px; color: var(--p-text-muted-color)">
						{{ slotProps.option.description }}
					</div>
				</div>
			</template>
		</Select>
	</div>
</template>

<script setup lang="ts">
import Select from 'primevue/select'
import { computed, watch } from 'vue'
import { supportedFakerMethods } from '@codecannon/schemas/interfaces/fakerMethods'
import type { EnrichedColumn } from '@codecannon/schemas/schemas/EnrichedColumn'

const props = defineProps<{
	column: EnrichedColumn
}>()

const fakerMethod = computed({ get: getFakerMethod, set: setFakerMethod })
const fakerMethodsOptions = computed(() => {
	return supportedFakerMethods[props.column.type]!.supported
})

watch(
	() => props.column.type,
	() => {
		if (
			props.column.fakerMethod &&
			!fakerMethodsOptions.value.find((faker) => faker.method === props.column.fakerMethod!.method)
		) {
			fakerMethod.value = undefined
		}
		if (!props.column.fakerMethod) {
			props.column.fakerMethod =
				(supportedFakerMethods[props.column.type]?.default
					? structuredClone(supportedFakerMethods[props.column.type]?.default)
					: undefined) ?? undefined
		}
	},
	{
		immediate: true,
	},
)

function getFakerMethod() {
	return props.column.fakerMethod
}

function setFakerMethod(fakerMethod: Exclude<EnrichedColumn['fakerMethod'], null>) {
	props.column.fakerMethod = fakerMethod
}
</script>

<style lang="scss" scoped>
.faker-method__container {
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin-bottom: 16px;

	&:last-of-type {
		margin-bottom: 0;
	}

	&--span {
		grid-column: 1 / -1;
	}

	.faker-method__select {
		width: 100%;
	}
}

.faker-method__select-value {
	display: flex;
	flex-direction: column;

	.faker-method__name {
		font-size: 14px;
		color: var(--p-text-color);
	}

	.faker-method__description {
		font-size: 12px;
		color: var(--p-text-muted-color);
	}

	.faker-method__placeholder {
		font-size: 14px;
		color: var(--p-text-muted-color);
	}
}
</style>
